// extracted by mini-css-extract-plugin
module.exports = {"typeWrapper":"CreationType-module--typeWrapper--1rrXq","innerTypes":"CreationType-module--innerTypes--1dbDn"};